import { render, staticRenderFns } from "./list-item.vue?vue&type=template&id=3a6053c0&"
import script from "./list-item.vue?vue&type=script&lang=js&"
export * from "./list-item.vue?vue&type=script&lang=js&"
import style0 from "./list-item.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "list-item.vue"
export default component.exports